import React, { useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

export default function GoogleLoginButton({ onSuccess, onError, text = 'Continuer avec Google' }) {
  const { loginWithGoogle, GOOGLE_CLIENT_ID } = useAuth();
  const btnRef = useRef(null);
  const initialized = useRef(false);

  const handleCredentialResponse = useCallback(async (response) => {
    try {
      await loginWithGoogle(response.credential);
      onSuccess?.();
    } catch (err) {
      onError?.(err.response?.data?.detail || 'Erreur de connexion Google');
    }
  }, [loginWithGoogle, onSuccess, onError]);

  useEffect(() => {
    if (initialized.current) return;

    const initGoogle = () => {
      if (!window.google?.accounts?.id) return;
      initialized.current = true;

      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
      });

      if (btnRef.current) {
        window.google.accounts.id.renderButton(btnRef.current, {
          type: 'standard',
          theme: 'filled_black',
          size: 'large',
          text: 'continue_with',
          shape: 'pill',
          logo_alignment: 'left',
          width: btnRef.current.offsetWidth || 400,
        });
      }
    };

    if (window.google?.accounts?.id) {
      initGoogle();
    } else {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = initGoogle;
      document.head.appendChild(script);
    }
  }, [GOOGLE_CLIENT_ID, handleCredentialResponse]);

  return (
    <div className="w-full">
      <div className="flex items-center gap-4 my-6">
        <div className="flex-1 h-px bg-white/10" />
        <span className="text-xs text-white/30 uppercase tracking-wider font-medium">ou</span>
        <div className="flex-1 h-px bg-white/10" />
      </div>
      <div ref={btnRef} data-testid="google-login-btn" className="flex justify-center w-full [&>div]:!w-full" />
    </div>
  );
}
